var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolomobileicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.632,
    height: 25.028,
    viewBox: "0 0 15.632 25.028",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38154",
    "data-name": "Path 38154",
    d: "M524.144,35.3H512.1a1.8,1.8,0,0,0-1.8,1.8v21.44a1.8,1.8,0,0,0,1.8,1.792h12.042a1.8,1.8,0,0,0,1.8-1.792V37.1A1.8,1.8,0,0,0,524.144,35.3ZM515.4,37.38h5.438a.473.473,0,1,1,0,.946H515.4a.473.473,0,0,1,0-.946Zm8.2,18.174H512.64V40.076h10.969Z",
    transform: "translate(-510.307 -35.301)",
    fill: "#3c3c3b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolomobileicon);
export default __webpack_public_path__ + "static/media/solo mobile icon.0716ae3a95667f83a6d6846e87c0b376.svg";
export { ForwardRef as ReactComponent };